import {styles} from "../../stylesheets/simulateurs.css";
import ButtonYesno from "../buttons/button.yesno";
import TextfieldNumber from "../textfields/textfield.number";

// example of component use:
// <Promesse 
//   handleChange={handleChange}
//   setPromesse={setPromesse}
//   promesse={promesse}
//   setMontantPromesse={setMontantPromesse}
// />

//Sims integrating this component must be included in the simuDependances variable inside generate.PDF.js in order to show the corresponding result line in the PDF

const Promesse = (props) => {

    return (
        <>
        <div className="cardRow">
          <div style={styles.cardElemVerticalyCenter}>
            Y a-t-il une promesse de vente reçue sous forme authentique ?
          </div>
          <div>
            <ButtonYesno handleChange={props.handleChange} setter={props.setPromesse} reduxKey={"promesse"} fieldUndefined={false} defaultValue={0} />
          </div>
        </div>
        {parseInt(props.promesse) === 1 ? (
          <div className="cardRow">
            <div style={styles.cardElemVerticalyCenter}>
              Indiquer le montant HT des honoraires de rédaction (s'il y a lieu) :
            </div>
            <TextfieldNumber
              handleChange={props.handleChange}
              type={"number"}
              placeholder={"Indiquer le montant"}
              setter={props.setMontantPromesse}
              reduxKey={"montant_promesse"}
            />
          </div>
        ) : null}
        </>
    );
};

export default Promesse;